import cn from "@/utils/mergeClassNames";
import React, { type ReactNode, useMemo } from "react";
import LoadingSpinner from "../Loading/LoadingSpinner";

type Props = React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> & {
  clean?: boolean;
  shape?: "normal" | "gradient";
  color?: "primary" | "primary-gradient" | "neutral";
  size?: "xs" | "sm" | "md" | "lg";
  loading?: boolean;
  loadingClassName?: string;
  prefix?: ReactNode;
  suffix?: ReactNode;
};

const Button = ({
  className,
  children,
  color,
  loading,
  prefix,
  suffix,
  size = "sm",
  shape = "gradient",
  loadingClassName,
  clean = false,
  ...props
}: Props) => {
  const sizeClassName = `btn-${size}`;

  const shapeClassName = useMemo(() => {
    if (shape === "normal") {
      return "border-0 rounded";
    } else if (shape === "gradient") {
      return "rounded-full";
    }
  }, [shape]);

  const colorClassName = useMemo(() => {
    if (color === "primary") {
      return "btn-primary bg-primary-btn text-white  ";
    } else if (color === "primary-gradient") {
      return " bg-primary-btn btn-primary-gradient text-white ";
    } else if (color === "neutral") {
      return "btn-ghost bg-metal-50 text-metal-700";
    }
  }, [color]);

  const loadingSize = useMemo(() => {
    if (size === "xs" || size === "sm") {
      return "size-4";
    } else if (size === "md" || size === "lg") {
      return "size-6";
    }
  }, [size]);

  return (
    <button
      type="button"
      {...props}
      className={
        clean
          ? className
          : cn("btn font-normal whitespace-nowrap", sizeClassName, colorClassName, shapeClassName, className)
      }>
      {loading ? (
        <div className="flex items-center justify-center">
          <LoadingSpinner className={cn(loadingSize, loadingClassName)} />
        </div>
      ) : (
        <>
          {prefix}

          {children}

          {suffix}
        </>
      )}
    </button>
  );
};

export default Button;
